export const localFeatureIds = [
  //
  'daydream',
  'export video',
  'smartlook-canvas',
  'onboarding-pro-schedule',
  'signup-tracking-page',
  'price-alert',
  'slazzer',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'viz-manual-distort',
  'viz-magic-render-floorplan',
  'viz-magic-erase-hide-feedback',
  'viz-blueprint-import-contents',
  'image-to-vizi',
  'pricing-3',
  'new-signup-soft-join',
] as const

export const externalFeatureIds = [
  //
  'daydream',
  'smartlook-canvas',
  'onboarding-pro-schedule',
  'signup-tracking-page',
  'price-alert',
  'slazzer',
  'viz-demo-overlay',
  'viz-take-photo-button',
  'viz-manual-distort',
  'viz-magic-render-floorplan',
  'viz-magic-erase-hide-feedback',
  'viz-blueprint-import-contents',
  'image-to-vizi',
  'pricing-3',
  'new-signup-soft-join',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
